import React from 'react';
import {connect} from 'react-redux';
import DataTable from 'react-data-table-component';
import Message from '../layout/Message';
import Button from '../layout/Button';

import {
    fetchPianoTechPianoList,
    FIND_PIANOTECHPIANO_STARTED,
    FIND_PIANOTECHPIANO_SUCCEEDED,
    findPianoTechPiano,
} from '../../actions/PianoTechPianoActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_ADD,
    defaultPianoTechPiano,
} from '../../app-constants';

const mapStateToProps = state => ({
    pianoTechPiano: state.pianoTechPiano,
    user: state.user,
});

class PianoTechPianoTable extends React.PureComponent {
    componentDidMount() {
        //Retrieve list if they are not in state
        if (!this.props.pianoTechPiano.pianoTechPianoList || this.props.pianoTechPiano.pianoTechPianoList.length === 0)
            this.props.dispatch(fetchPianoTechPianoList());
    }

    refreshList = () => {
        this.props.dispatch(fetchPianoTechPianoList());
    }

    addPianoTechPiano = () => {
        const originalPianoTechPiano = Object.assign({}, defaultPianoTechPiano);
        const pianoTechPiano = Object.assign({}, defaultPianoTechPiano);
        
        this.props.dispatch({
            type: FIND_PIANOTECHPIANO_STARTED,
            maintenanceType: MAINTENANCE_TYPE_ADD,
            title: "Add PianoTechPiano",
        });
        
        this.props.dispatch({
            type: FIND_PIANOTECHPIANO_SUCCEEDED,
            pianoTechPiano,
            originalPianoTechPiano,
        });
        
    }

    viewPianoTechPiano(pianoId) {
        this.props.dispatch({
            type: FIND_PIANOTECHPIANO_STARTED,
            maintenanceType: MAINTENANCE_TYPE_VIEW,
            title: "View PianoTechPiano",
        });
        
        this.props.dispatch(findPianoTechPiano(pianoId));
    }

    render() {
        const columns = [
                    {
                        name: 'Piano Id',
                        selector: row => row.pianoId,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Company Id',
                        selector: row => row.companyId,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Customer Id',
                        selector: row => row.customerId,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Device Type',
                        selector: row => row.deviceType,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Year',
                        selector: row => row.year,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Make',
                        selector: row => row.make,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Model',
                        selector: row => row.model,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'SerialNumber',
                        selector: row => row.serialNumber,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Nickname',
                        selector: row => row.nickname,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'DefaultMinutesPerAppointment',
                        selector: row => row.defaultMinutesPerAppointment,
                        sortable: true,
                        width: '10%',
                    },
                    {
                        name: 'Buttons',
                        width: '8%',
                        cell: row =>
                        (
                            <>
                                <button
                                    className="bluebutton"
                                    onClick={() => { this.viewPianoTechPiano(row.pianoId) }}
                                    style={{ marginRight: "5px" }}
                                    >View
                                </button>
                            </>
                        )
                    },
        ]
        const customStyles = {
            rows: {
                style: {
                    minheight: '20px',
                }
            }
        }

        return (
        <div>
            <Message message={this.props.pianoTechPiano.message} type={this.props.pianoTechPiano.messageType} />
            <table width="100%">
                <tbody>
                    <tr>
                        <td className='lefttext'>
                            <Button className="bluebutton" description="Refresh" onClick={this.refreshList} />
                        </td>
                        {this.props.user.allowAdd &&
                            <td className='righttext'>
                                <Button className="bluebutton" description="Add PianoTechPiano" onClick={this.addPianoTechPiano} />
                            </td>
                        }
                    </tr>
                </tbody>
            </table>
            <DataTable
                title='PianoTechPiano'
                className='app-table'
                columns={columns}
                customStyles={customStyles}
                striped
                data={this.props.pianoTechPiano.pianoTechPianoList}
                defaultSortField="nickname"
                highlightOnHover
                pagination
                onRowClicked={
                    (row) => { this.viewPianoTechPiano(row.pianoId) }
                }
            />
        </div>
        );
    }

}

export default connect(mapStateToProps)(PianoTechPianoTable);
